<template>
    <div id="userList" class="background-ash pl20 pr20 pb20">
        <div class="search_list background-white">
            <ul class="lists">
                <li>
                    <span>企业名称</span>
                    <el-input size="small" class="width180" @keyup.native.enter="searchGetDataList"
                        v-model="getDataParam.companyNameLike" placeholder="请输入企业名称"></el-input>
                </li>
                <li>
                    <span>注册时间</span>
                    <el-date-picker size="small" v-model="time1" type="daterange" range-separator="至"
                        start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
                </li>
                <li>
                    <span>最近登录</span>
                    <el-date-picker size="small" v-model="time2" type="daterange" range-separator="至"
                        start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
                </li>
                <li>
                    <span>手机号码</span>
                    <el-input size="small" class="width130" @keyup.native.enter="searchGetDataList"
                        v-model="getDataParam.mobileLike" placeholder="请输入手机号"></el-input>
                </li>
                <li>
                    <span>审核状态</span>
                    <el-select size="small" class="select width100" collapse-tags
                        v-model="getDataParam.authenticationStatus">
                        <el-option label="全部" value="all"></el-option>
                        <el-option label="待认证" value="INIT"></el-option>
                        <el-option label="认证审核中" value="AUDITING"></el-option>
                        <el-option label="认证通过" value="PASS"></el-option>
                        <el-option label="认证失败" value="FAILED"></el-option>
                        <el-option label="已过期" value="EXPIRE"></el-option>
                    </el-select>
                </li>
                <li>
                    <span>账号状态</span>
                    <el-select size="small" class="select width100" collapse-tags v-model="getDataParam.status">
                        <el-option label="全部" value="all"></el-option>
                        <el-option label="启用" value="ENABLED"></el-option>
                        <el-option label="禁用" value="DISABLED"></el-option>
                    </el-select>
                </li>
                <li>
                    <span>省</span>
                    <el-select size="small" class="select width100" collapse-tags v-model="getDataParam.provinceId"
                        clearable>
                        <el-option v-for="item in allProvince" :label="item.name" :value="item.id"
                            :key="item.id"></el-option>
                    </el-select>
                </li>
                <li v-if="getDataParam.provinceId">
                    <span>市</span>
                    <el-select size="small" class="select width100" collapse-tags v-model="getDataParam.cityId"
                        clearable>
                        <el-option v-for="item in allCity" :label="item.name" :value="item.id"
                            :key="item.id"></el-option>
                    </el-select>
                </li>
                <li v-if="getDataParam.cityId">
                    <span>区</span>
                    <el-select size="small" class="select width100" collapse-tags v-model="getDataParam.districtId"
                        clearable>
                        <el-option v-for="item in allDistrict" :label="item.name" :value="item.id"
                            :key="item.id"></el-option>
                    </el-select>
                </li>
                <li>
                    <span>效期状态</span>
                    <el-select size="small" class="select width100" collapse-tags v-model="getDataParam.expireStatus">
                        <el-option label="全部" value=""></el-option>
                        <el-option label="使用中" value="USE"></el-option>
                        <el-option label="即将过期" value="NEAR_EXPIR"></el-option>
                        <el-option label="已过期" value="EXPIRED"></el-option>
                    </el-select>
                </li>
                <li>
                    <span>所属分组</span>
                    <el-select size="small" class="select width200" v-model="getDataParam.groupId" clearable filterable>
                        <el-option :label="item.name" :value="item.id" v-for="item in groupList"
                            :key="item.id"></el-option>
                    </el-select>
                </li>
                <li>
                    <span>客户类型</span>
                    <el-select size="small" class="select width200" v-model="getDataParam.customType" clearable
                        filterable>
                        <el-option :label="item.name" :value="item.value" v-for="item in customTypeList"
                            :key="item.value"></el-option>
                    </el-select>
                </li>
                <li>
                    <span>用户类型</span>
                    <el-select size="small" class="select width200" v-model="getDataParam.userType" clearable
                        filterable>
                        <el-option :label="item.name" :value="item.value" v-for="item in userTypeList"
                            :key="item.value"></el-option>
                    </el-select>
                </li>
            </ul>
            <div class="btns">
                <el-button size="small" type="primary" @click="searchGetDataList">搜索</el-button>
            </div>
        </div>
        <!--内容-->
        <div class="pt20 content">
            <!--表头操作-->
            <div class="watchBar">
                <div class="total-user left color-blue">共{{ totalCount }}位用户&nbsp;&nbsp;&nbsp;&nbsp;
                    即将过期：{{ statics.nearExpir }}&nbsp;&nbsp;&nbsp;&nbsp;
                    已过期：{{ statics.expired }}
                </div>
                <div class="btns right">
                    <el-button size="small" class="export-right" type="primary" plain @click="getExport">导出</el-button>
                    <el-button type="primary" size="small" @click="addUser()">添加用户</el-button>
                </div>
            </div>
            <!--表格-->
            <div class="tab">
                <el-table ref="checkList" :row-key="getRowKey" @selection-change="handleSelectionChange" size="mini"
                    :data="dataList" tooltip-effect="dark" height="100%">
                    <el-table-column type="selection" width="40" fixed :reserve-selection="true"></el-table-column>
                    <el-table-column label="用户ID" width="80">
                        <template slot-scope="scope">{{ scope.row.id || '' }}</template>
                    </el-table-column>
                    <el-table-column label="手机号" prop="mobile"></el-table-column>
                    <el-table-column label="注册时间" width="140" prop="gmtRegister"></el-table-column>
                    <el-table-column label="最近登录" width="140" prop="gmtLastLogin"></el-table-column>
                    <el-table-column label="查询条数" prop="queryNum"></el-table-column>
                    <el-table-column label="地区" width="250">
                        <template slot-scope="scope">
                            {{ scope.row.province + scope.row.city + scope.row.district }}
                        </template>
                    </el-table-column>
                    <el-table-column label="客户类型" prop="customType" :formatter="formatCustomType"></el-table-column>
                    <el-table-column label="用户类型" prop="userType" :formatter="formatUserType"></el-table-column>
                    <el-table-column label="企业名称" prop="companyName"></el-table-column>
                    <el-table-column label="审核状态">
                        <template slot-scope="scope">
                            <span v-if="scope.row.authenticationStatus === 'INIT'">待认证</span>
                            <span v-else-if="scope.row.authenticationStatus === 'AUDITING'">认证审核中</span>
                            <span v-else-if="scope.row.authenticationStatus === 'PASS'">认证通过</span>
                            <span v-else-if="scope.row.authenticationStatus === 'FAILED'">认证失败</span>
                            <span v-else>已过期</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="状态">
                        <template slot-scope="scope">
                            <span v-if="scope.row.status === 'ENABLED'">启用</span>
                            <span v-else>禁用</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="有效期">
                        <span slot-scope="scope">
                            <p v-if="scope.row.expireStatus === 'USE'">{{ scope.row.gmtExpire }}</p>
                            <p v-if="scope.row.expireStatus === 'NEAR_EXPIR'" class="color-red">{{
                                scope.row.gmtExpire
                            }}</p>
                            <p v-if="scope.row.expireStatus === 'EXPIRED'" class="color-909399">{{
                                scope.row.gmtExpire
                            }}</p>
                        </span>
                    </el-table-column>
                    <el-table-column label="每7天可更换设备">
                        <span slot-scope="scope">{{ scope.row.sevenReplaceDeviceNum }}个设备</span>
                    </el-table-column>
                    <el-table-column label="所属分组" prop="groups"></el-table-column>
                    <el-table-column label="操作" width="320" fixed="right">
                        <template slot-scope="scope">
                            <el-button type="text" @click="personRecords(scope.row)">查询记录</el-button>
                            <el-button type="text" @click="updateUser(scope.row)">编辑</el-button>
                            <el-button type="text" @click="goToUserDetail(scope.row)">详情</el-button>
                            <el-button type="text" @click="gotoAudit(scope.row)">资质审核</el-button>
                            <el-button type="text"
                                @click="curUser = scope.row, userTime = scope.row.gmtExpire, userNumber = scope.row.sevenReplaceDeviceNum, isShowUserAstrict = !isShowUserAstrict">帐号限制</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="page background-white text-right p20">
                <el-pagination @size-change="changePageSize" @current-change="getDataList"
                    :current-page.sync="getDataParam.page" :page-sizes="[10, 20, 50, 100]"
                    :page-size="getDataParam.size" layout="total, sizes, prev, pager, next, jumper" :total="totalCount">
                </el-pagination>
            </div>
        </div>
        <!--添加/修改用户-->
        <el-dialog :title="title" :visible.sync="dialogVisible" width="780px" v-loading="loading">
            <el-form :model="addUserParam" status-icon :rules="rules" ref="user" label-width="100px"
                class="demo-ruleForm">
                <el-col :span="17">
                    <el-form-item label="账号" prop="mobile">
                        <el-input :disabled="title !== '添加用户'" v-model.trim="addUserParam.mobile" type="text"
                            class="width400" :autofocus="true" placeholder="请输入用户账号"></el-input>
                    </el-form-item>
                    <el-form-item v-if="title === '添加用户'" label="登录密码" prop="loginPassword">
                        <el-input v-model.trim="addUserParam.loginPassword" type="password" class="width400"
                            placeholder="请输入登录密码"></el-input>
                    </el-form-item>
                    <el-form-item label="公司名称" prop="companyName">
                        <el-input v-model.trim="addUserParam.companyName" class="width400"
                            placeholder="请输入公司名称"></el-input>
                    </el-form-item>
                    <el-form-item label="省" prop="provinceId">
                        <el-select size="small" class="select width100" collapse-tags v-model="addUserParam.provinceId"
                            @change="changeProvince">
                            <el-option v-for="item in addAllProvince" :label="item.name"
                                :value="item.id + '/' + item.name" :key="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="市" prop="cityId">
                        <el-select size="small" class="select width100" collapse-tags v-model="addUserParam.cityId"
                            @change="changeCity">
                            <el-option v-for="item in addAllCity" :label="item.name" :value="item.id + '/' + item.name"
                                :key="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="区" prop="districtId">
                        <el-select size="small" class="select width100" collapse-tags v-model="addUserParam.districtId">
                            <el-option v-for="item in addAllDistrict" :label="item.name"
                                :value="item.id + '/' + item.name" :key="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="审核状态">
                        <el-select size="small" v-model="addUserParam.authenticationStatus" placeholder="请选择"
                            class="width220">
                            <el-option label="待认证" value="INIT"></el-option>
                            <el-option label="认证审核中" value="AUDITING"></el-option>
                            <el-option label="认证通过" value="PASS"></el-option>
                            <el-option label="认证失败" value="FAILED"></el-option>
                            <el-option label="已过期" value="EXPIRE"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="所属分组">
                        <el-select size="small" v-model="addUserParam.groupIdList" placeholder="请选择" class="width220"
                            multiple filterable collapse-tags>
                            <el-option :label="item.name" :value="item.id" v-for="item in groupList"
                                :key="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="客户类型" prop="customType">
                        <el-select size="small" v-model.trim="addUserParam.customType" clearable filterable>
                            <el-option :label="item.name" :value="item.value" v-for="item in customTypeList"
                                :key="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="用户类型" class="last-form-item">
                        <el-radio-group v-model="addUserParam.userType">
                            <el-radio label='CHAIN'>连锁</el-radio>
                            <el-radio label='MONOMER'>单体</el-radio>
                            <el-radio label='API'>接口上传</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="状态" class="last-form-item">
                        <el-radio-group v-model="addUserParam.status">
                            <el-radio label='ENABLED'>启用</el-radio>
                            <el-radio label='DISABLED'>禁用</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <div class="color-303133 b" style="margin-top:-18px;">可查询平台</div>
                    <div class="platform mt10">
                        <el-checkbox-group v-model="addUserParam.platforms">
                            <el-checkbox class="mb10" v-for="item in allPlatform" :label="item.platformCode"
                                :key="item.platformCode">{{ item.platformName }}</el-checkbox>
                        </el-checkbox-group>
                        <div class="mt10">
                            <el-radio-group v-model="isCheckAllBox">
                                <el-radio label="all">全选</el-radio>
                                <el-radio label="back">反选</el-radio>
                            </el-radio-group>
                        </div>
                    </div>
                </el-col>
                <div style="clear:both;"></div>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button size="small" @click="dialogVisible = !dialogVisible">&emsp;取消&emsp;</el-button>
                <el-button type="primary" :disabled="disabled" size="small" @click="save">&emsp;确定&emsp;</el-button>
            </span>
        </el-dialog>

        <!--帐号限制-->
        <el-dialog title="帐号限制" :visible.sync="isShowUserAstrict" :destroy-on-close="true" width="580px"
            v-loading="loading">
            <ul style="line-height: 30px;">
                <li class="flex pb5">
                    <span style="width: 80px;" class="pr10 text-right">有效期</span>
                    <div class="f1">截止于<el-date-picker class="ml5" size="small" v-model="userTime" type="date"
                            placeholder="选择日期"></el-date-picker></div>
                </li>
                <li class="flex pt5 pb5">
                    <span style="width: 80px;" class="pr10 text-right">登录限制</span>
                    <div class="f1">每7天可更换<el-input
                            onkeyup="if(this.value.length==1){this.value=this.value.replace(/[^1-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
                            onafterpaste="if(this.value.length==1){this.value=this.value.replace(/[^1-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
                            style="width: 80px;padding: 0;" maxlength="6" class="text-center ml5 mr5" size="small"
                            v-model="userNumber"></el-input>个设备</div>
                </li>
                <li class="flex pt5">
                    <span style="width: 80px;" class="pr10 text-right">&nbsp;</span>
                    <div class="f1">
                        <el-button size="small"
                            @click="isShowUserAstrict = !isShowUserAstrict">&emsp;取消&emsp;</el-button>
                        <el-button type="primary" size="small" @click="setUserAstrict()">&emsp;确定&emsp;</el-button>
                    </div>
                </li>
            </ul>
        </el-dialog>
    </div>
</template>

<script>
const userTypeList = [{ name: '单体', value: 'MONOMER' }, { name: '连锁', value: 'CHAIN' }]
const customTypeList = [
    { name: '员工账号', value: 'STAFF' },
    { name: '已付费客户', value: 'PAID' },
    { name: '试用客户', value: 'PROBATION' },
    { name: '战略客户', value: 'STRATEGY' },
    { name: '免费客户', value: 'FREE' },
    { name: '代理商账号', value: 'AGENT' },
    { name: '代理已付费客户', value: 'AGENT_PAID' },
    { name: '代理试用客户', value: 'AGENT_PROBATION' }]
export default {
    name: 'userList',
    data() {
        let checkPhone = (rule, value, callback) => {
            var reg = /^1[3456789]\d{9}$/;
            if (!reg.test(value)) {
                callback(new Error('手机格式不正确'));
            } else {
                callback();
            }
        };
        let validatePass = (rule, value, callback) => {
            var reg = /^[0-9A-Za-z]{6,20}$/;
            if (value === '') {
                callback(new Error('请输入密码'));
            } else {
                if (!reg.test(value)) {
                    callback(new Error('只能输入数字和字母,且长度在6到20位之间'));
                } else {
                    callback();
                }
            }
        };
        return {
            getDataParam: {
                mobileLike: '',
                companyNameLike: '',
                provinceId: null,
                cityId: null,
                districtId: null,
                status: 'all', //ENABLED 启用 DISABLED 禁用
                authenticationStatus: 'all', //INIT 待认证  PASS 认证通过  EXPIRE 已过期
                geGmtRegister: '', //注册开始时间
                leGmtRegister: '', //注册结束时间
                geGmtLastLogin: '', //登录开始时间
                leGmtLastLogin: '', //登录结束时间
                expireStatus: '',
                groupId: null, //所属分组
                userType: '',
                customType: '',
                page: 1,
                size: 10
            },
            time1: '',
            time2: '',
            dataList: [],
            checkList: [],
            totalCount: 0,
            dialogVisible: false,
            title: '',
            addUserParam: {
                mobile: '', //账号
                loginPassword: '',
                companyName: '',
                provinceId: null,
                province: '',
                cityId: null,
                city: '',
                districtId: null,
                district: '',
                authenticationStatus: 'INIT',
                status: 'ENABLED',
                platforms: [], //可查询平台
                userType: 'CHAIN', //MONOMER-单体；CHAIN-连锁；API-接口上传
                customType: '',
                groupIdList: [], //所属分组
            },
            isCheckAllBox: '', //all 全选，back 反选
            allPlatform: [],//所有平台
            rules: {
                mobile: [{ required: true, message: '请登录账号', trigger: 'blur' },
                { validator: checkPhone, trigger: 'blur' }],
                loginPassword: [{ required: true, message: '请输入登录密码', trigger: 'blur' },
                { validator: validatePass, trigger: 'blur' }],
                companyName: [{ required: true, message: '请输入公司名称', trigger: 'blur' }],
                provinceId: [{ required: true, message: '请选择省', trigger: 'blur' }],
                cityId: [{ required: true, message: '请选择市', trigger: 'blur' }],
                districtId: [{ required: true, message: '请选择区', trigger: 'blur' }],
                customType: [{ required: true, message: '请选择客户类型', trigger: 'blur' }]
            },
            allProvince: [],
            allCity: [],
            allDistrict: [],
            addAllProvince: [],
            addAllCity: [],
            addAllDistrict: [],
            loading: false,
            disabled: false,
            curUser: {}, // 当前修改账号
            userTime: '', // 有效期
            userNumber: 0, // 每7天可更换设备数量
            isShowUserAstrict: false, // 是否显示帐号限制界面
            statics: { // 统计
                nearExpir: 0,
                expired: 0,
            },
            groupList: [], //所有分组
            userTypeList: userTypeList,
            customTypeList: customTypeList
        }
    },
    watch: {
        dialogVisible(val) {
            if (!val) {
                this.$refs.user.resetFields();//清空验证报错
                this.clearAddUserParam();
                this.$refs.user.clearValidate();
            }
        },
        'getDataParam.provinceId': function (val) {
            this.getDataParam.cityId = null;
            this.getDataParam.districtId = null;
            if (!!val) {
                this.$http('POST', '/admin/region/findByPid', {}, { id: val }, (status, res) => {
                    if (status) {
                        if (!!res.data && res.data.length > 0) {
                            this.allCity = res.data;
                        } else {
                            this.allCity = [];
                        }
                    }
                })
            }

        },
        'getDataParam.cityId': function (val) {
            this.getDataParam.districtId = null;
            if (!!val) {
                this.$http('POST', '/admin/region/findByPid', {}, { id: val }, (status, res) => {
                    if (status) {
                        if (!!res.data && res.data.length > 0) {
                            this.allDistrict = res.data;
                        } else {
                            this.allDistrict = [];
                        }
                    }
                });
            }
        },
        isCheckAllBox(val) {
            if (val == 'all') {
                this.addUserParam.platforms = this.allPlatform.map((item) => { return item.platformCode });
            } else {
                //反选
                this.allPlatform.forEach((item) => {
                    let index = this.addUserParam.platforms.indexOf(item.platformCode);
                    if (index > -1) {
                        this.addUserParam.platforms.splice(index, 1);
                    } else {
                        this.addUserParam.platforms.push(item.platformCode);
                    }
                })
            }
        },
    },
    // beforeRouteEnter (to, from, next) {
    //     let groupId = to.query.groupId
    //     next(vm=>{
    //         if (groupId) {
    //             //说明是从分组那边跳转过来的
    //             vm.getDataParam.groupId = groupId
    //             vm.time2 = [];
    //         }
    //         if (from.fullPath === '/groupList' && groupId) {
    //             vm.getDataList();
    //         } else {
    //             vm.getDataParam.groupId = ''
    //             vm.getDataList();
    //         }
    //     });
    // },
    methods: {
        //获取所有分组
        getGroupList() {
            this.$http('post', '/admin/userGroup/findAllGroup', {}, {}, (status, res) => {
                if (status) {
                    if (!!res.data && res.data.length > 0) {
                        this.groupList = res.data;
                    } else {
                        this.groupList = [];
                    }
                    let groupId = this.$route.query.groupId
                    if (groupId) {
                        //说明是从分组那边跳转过来的
                        this.getDataParam.groupId = +groupId
                        this.time2 = [];
                    } else {
                        this.getDataParam.groupId = ''
                    }
                    this.getDataList();
                }
            });
        },
        //获取所有平台
        getAllPlatform() {
            this.loading = true;
            this.$http('POST', '/admin/platform/all', {}, {}, (status, res) => {
                this.loading = false;
                if (status) {
                    console.log('data.......', typeof res.data);
                    if (!!res.data && res.data.length > 0) {
                        this.allPlatform = res.data;
                    } else {
                        this.allPlatform = [];
                    }
                }
            })
        },
        getCity(id) {
            this.$http('POST', '/admin/region/findByPid', {}, { id: id }, (status, res) => {
                if (status) {
                    if (!!res.data && res.data.length > 0) {
                        this.addAllCity = res.data;
                    } else {
                        this.addAllCity = [];
                    }
                }
            })
        },
        getDistance(id) {
            this.$http('POST', '/admin/region/findByPid', {}, { id: id }, (status, res) => {
                if (status) {
                    if (!!res.data && res.data.length > 0) {
                        this.addAllDistrict = res.data;
                    } else {
                        this.addAllDistrict = [];
                    }
                }
            });
        },
        clearAddUserParam() {
            this.addUserParam.mobile = '';
            this.addUserParam.loginPassword = '';
            this.addUserParam.companyName = '';
            this.addUserParam.provinceId = null;
            this.addUserParam.province = '';
            this.addUserParam.cityId = null;
            this.addUserParam.city = '';
            this.addUserParam.districtId = null;
            this.addUserParam.district = '';
            this.addUserParam.authenticationStatus = 'INIT';
            this.addUserParam.status = 'ENABLED';
            this.addUserParam.platforms = [];
            this.addUserParam.userType = 'CHAIN';
            this.isCheckAllBox = "";
        },
        changeProvince(val) {
            this.addUserParam.cityId = null;
            this.addUserParam.districtId = null;
            if (val) {
                let id = val.split('/')[0];
                this.getCity(id);
            }
        },
        changeCity(val) {
            this.addUserParam.districtId = null;
            if (!!val) {
                let id = val.split('/')[0];
                this.getDistance(id);
            }
        },
        //添加用户
        addUser() {
            this.dialogVisible = true;
            this.title = '添加用户';
            this.clearAddUserParam();
            this.getAllPlatform();
        },
        updateUser(item) {
            this.title = '编辑用户';
            this.clearAddUserParam();
            this.$http('POST', '/admin/user/view', {}, { id: item.id }, (statu, res) => {
                if (statu) {
                    this.$http('POST', '/admin/platform/all', {}, {}, (status, resP) => {
                        if (status) {
                            if (!!resP.data && resP.data.length > 0) {
                                this.allPlatform = resP.data;
                            } else {
                                this.allPlatform = [];
                            }
                            if (!res.data.platforms) {
                                res.data.platforms = [];
                            }
                            this.addUserParam = res.data;
                            if (res.data.platforms.length > 0) {
                                this.addUserParam.platforms = res.data.platforms.map((item) => { return item.platformCode });
                            }
                            this.getCity(res.data.provinceId);
                            this.getDistance(res.data.cityId);
                            this.addUserParam.provinceId = res.data.provinceId + '/' + res.data.province;
                            this.addUserParam.cityId = res.data.cityId + '/' + res.data.city;
                            this.addUserParam.districtId = res.data.districtId + '/' + res.data.district;
                            this.dialogVisible = true;
                            this.addUserParam.id = item.id;
                            this.$refs.user.clearValidate();
                        }
                    });
                }
            })
        },
        save() {
            this.$refs.user.validate((validator) => {
                if (validator) {
                    let param = { ...this.addUserParam };
                    if (!!param.loginPassword) {
                        param.loginPassword = this.md5(param.loginPassword);
                    }
                    param.provinceId = parseInt(this.addUserParam.provinceId.split('/')[0]);
                    param.province = this.addUserParam.provinceId.split('/')[1];
                    param.cityId = parseInt(this.addUserParam.cityId.split('/')[0]);
                    param.city = this.addUserParam.cityId.split('/')[1];
                    param.districtId = parseInt(this.addUserParam.districtId.split('/')[0]);
                    param.district = this.addUserParam.districtId.split('/')[1];
                    this.disabled = true;
                    this.dialogVisible = true
                    this.$http('POST', '/admin/user/save', {}, param, (statu, res) => {
                        this.dialogVisible = false
                        this.disabled = false;
                        if (statu) {
                            this.$message({ message: res.message, type: 'success' });
                            this.dialogVisible = false;
                            this.getDataList();
                        }
                    })
                }
            })
        },
        //跳转到详情页
        goToUserDetail(row) {
            this.$router.push({ path: '/userList/detail', query: { id: row.id } });
        },
        //查询记录
        personRecords(row) {
            this.$router.push({ path: '/userList/personalRecords', query: { id: row.id } });
        },
        //资质审核
        gotoAudit(row) {
            this.$router.push({ path: '/userList/credentialsAudit', query: { id: row.id } });
        },
        //获取省
        getAllProvince() {
            this.$http('POST', '/admin/region/findAllProvince', {}, {}, (status, res) => {
                if (status) {
                    if (!!res.data && res.data.length > 0) {
                        this.allProvince = res.data;
                        this.addAllProvince = res.data;
                    } else {
                        this.allProvince = [];
                    }
                }
            })
        },
        searchGetDataList() {
            const reg = /^1[3456789]\d{9}$/;
            if (!!this.getDataParam.mobileLike && !reg.test(this.getDataParam.mobileLike)) {
                this.$message({ message: '手机格式不正确', type: 'error' });
            } else {
                this.getDataParam.page = 1;
                this.getDataList();
            }
        },
        //获取数据
        getDataList() {
            if (!!this.time1 && this.time1.length > 0) {
                this.getDataParam.geGmtRegister = this.$root.format(this.time1[0]);
                this.getDataParam.leGmtRegister = this.$root.format(this.time1[1]);
            } else {
                this.getDataParam.geGmtRegister = "";
                this.getDataParam.leGmtRegister = "";
            }
            if (!!this.time2 && this.time2.length > 0) {
                this.getDataParam.geGmtLastLogin = this.$root.format(this.time2[0]);
                this.getDataParam.leGmtLastLogin = this.$root.format(this.time2[1]);
            } else {
                this.getDataParam.geGmtLastLogin = "";
                this.getDataParam.leGmtLastLogin = "";
            }
            let param = { ...this.getDataParam };
            if (param.status === 'all') {
                param.status = null;
            }
            if (param.authenticationStatus === 'all') {
                param.authenticationStatus = null;
            }
            for (let key in param) {
                if (param[key] === '') {
                    delete param[key]
                }
            }
            param.page = (param.page - 1);
            this.getStatic(param)
            this.$http('POST', '/admin/user/page', {}, param, (status, res) => {
                if (status) {
                    if (!!res.content && res.content.length > 0) {
                        this.dataList = res.content;
                    } else {
                        this.dataList = [];
                    }
                    this.totalCount = res.totalCount;
                }
            })
        },
        // 获取统计数据
        getStatic(options) {
            this.$http('POST', '/admin/user/page/count', {}, options, (status, res) => {
                if (status) {
                    this.statics.nearExpir = res.data.nearExpir || 0
                    this.statics.expired = res.data.expired || 0
                }
            })
        },
        changePageSize(val) {
            this.getDataParam.size = val;
            this.getDataParam.page = 1;
            this.getDataList();
        },
        handleSelectionChange(select) {
            this.checkList = select.map((item) => { return item.id });
        },
        getExport() {
            if (!!this.time1 && this.time1.length > 0) {
                this.getDataParam.geGmtRegister = this.$root.format(this.time1[0]);
                this.getDataParam.leGmtRegister = this.$root.format(this.time1[1]);
            } else {
                this.getDataParam.geGmtRegister = "";
                this.getDataParam.leGmtRegister = "";
            }
            if (!!this.time2 && this.time2.length > 0) {
                this.getDataParam.geGmtLastLogin = this.$root.format(this.time2[0]);
                this.getDataParam.leGmtLastLogin = this.$root.format(this.time2[1]);
            } else {
                this.getDataParam.geGmtLastLogin = "";
                this.getDataParam.leGmtLastLogin = "";
            }
            let param = { ...this.getDataParam };
            if (param.status === 'all') {
                param.status = null;
            }
            if (param.authenticationStatus === 'all') {
                param.authenticationStatus = null;
            }
            // if (this.checkList.length > 0) {
            //     params.salesmanIds = this.checkList;
            // }
            for (let key in param) {
                if (param[key] === '') {
                    delete param[key]
                }
            }
            const loading = this.load();
            this.$http('POST', '/admin/user/export', {}, param, (status, res) => {
                loading.close();
                if (status) {
                    if (res.status === '200') {
                        this.educe(res.data);
                    }
                }
            })
        },
        //勾选复选框
        getRowKey(row) {
            return row.id
        },
        // 设置默认时间为最近一周
        setTime() {
            let end = new Date()
            let start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            this.time2 = [start, end]
        },
        // 设置帐号限制
        setUserAstrict() {
            if (this.userTime === '' || this.userTime == 'null') {
                this.error('请选择截止日期')
                return
            }
            if (+this.userNumber < 1) {
                this.error('只能输入正整数')
                return
            }
            let options = {
                userId: this.curUser.id, // 用户id
                gmtExpire: this.userTime, // 有效期
                sevenReplaceDeviceNum: this.userNumber // 7天可更换登录设备次数
            }
            let loading = this.load()
            this.$http('POST', '/admin/user/limit/set', {}, options, (status, res) => {
                loading.close()
                if (status) {
                    if (res.status === '200') {
                        this.success('操作成功')
                        this.isShowUserAstrict = false
                        this.getDataList()
                    }
                }
            })

        },
        formatUserType(row) {
            let name = ''
            this.userTypeList.forEach(item => {
                if (item.value === row.userType) {
                    name = item.name
                }
            })
            return name
        },
        formatCustomType(row) {
            let name = ''
            this.customTypeList.forEach(item => {
                if (item.value === row.customType) {
                    name = item.name
                }
            })
            return name
        }
    },
    mounted() {
        //判断来源
        this.setTime() // 设置默认登录时间
        this.getAllProvince();
        this.getGroupList()
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#userList {
    width: 100%;
    height: calc(100vh - 155px);
}

#userList .content {
    height: calc(100% - 91px);
}

#userList .content .tab {
    height: calc(100% - 125px);
}

#userList>>>.el-table th.type>.cell,
#userList>>>.el-table td.type>.cell {
    margin-left: 75px;
}

#userList>>>.width400.el-input {
    width: 400px;
    height: 36px;
    border-radius: 2px;
}

#userList>>>.width400.el-input .el-input__inner {
    width: 400px;
    height: 36px;
    border-radius: 2px;
}

#userList>>>.el-select.width120 {
    width: 120px;
    line-height: 36px;
}

#userList>>>.el-select.width120 .el-input__inner {
    height: 36px;
    border-radius: 2px;
}

#userList>>>.el-select.width220 {
    width: 220px;
    line-height: 36px;
}

#userList .platform {
    height: 477px;
    overflow-y: auto;
    border: 1px solid #EDF0F4;
    padding: 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/user/userList.vue